import { useContext } from "react";
import { DisclosureStateContext } from "react-aria-components";

interface InvoiceDisclosureTriggerProps {
  children: React.ReactNode;
  className: string;
}

export function InvoiceDisclosureTrigger({
  children,
  className,
}: InvoiceDisclosureTriggerProps) {
  const state = useContext(DisclosureStateContext);

  return (
    <div
      aria-expanded={state?.isExpanded ?? false}
      className={`flex w-full cursor-pointer text-left outline-hidden ${className}`}
      onClick={() => state?.toggle()}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          state?.toggle();
        }
      }}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
}
